// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__CnxaT","col":"Table_col__gU19G","fulfillmentStatus":"Table_fulfillmentStatus__Rtyc9","emailCol":"Table_emailCol__17vtc"};